/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Benefit_Web_Mobile_DescriptionInputs */

const en_pricing_benefit_web_mobile_description = /** @type {(inputs: Pricing_Benefit_Web_Mobile_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen on your phone or in your web browser.`)
};

const es_pricing_benefit_web_mobile_description = /** @type {(inputs: Pricing_Benefit_Web_Mobile_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escucha en tu teléfono o en tu navegador web.`)
};

/**
* | output |
* | --- |
* | "Listen on your phone or in your web browser." |
*
* @param {Pricing_Benefit_Web_Mobile_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_benefit_web_mobile_description = /** @type {((inputs?: Pricing_Benefit_Web_Mobile_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Benefit_Web_Mobile_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_benefit_web_mobile_description(inputs)
	return en_pricing_benefit_web_mobile_description(inputs)
});